module.exports = __webpack_public_path__ + "img/manage-data-3.836011b3.jpg";